const now = new Date();
let from = new Date();
from = from.setDate( from.getDate() - 60 );
const defaultValues = {
  unifyStartDay: {
    checked: false,
    count: 100,
  },
  perPopulation: false,
  chartType: 'confirmed',
  countries: ['US', 'Italy', 'Spain', 'China'],
  fromDate: new Date(from),
  toDate: now,
  scale: 'linear',
};


const getInitialChartParams = (search) => {
  const urlParams = new URLSearchParams(search);
  const unifyStartDay = urlParams.get('unifyStartDay') === 'true';
  const unifyStartDayCount = parseInt(urlParams.get('unifyStartDayCount'));
  const perPopulation = urlParams.get('perPopulation') === 'true' ;
  const chartType = urlParams.get('chartType');
  const countries = urlParams.get('countries') ? urlParams.get('countries').split(',') : undefined;
  const fromDate = urlParams.get('fromDate') ? new Date(urlParams.get('fromDate')) : null;
  const toDate = urlParams.get('toDate') ? new Date(urlParams.get('toDate')) : null;
  const scale = urlParams.get('scale');


  const initial = {
    unifyStartDay: {
      checked: unifyStartDay || defaultValues.unifyStartDay.checked,
      count: unifyStartDayCount || defaultValues.unifyStartDay.count,
    },
    perPopulation: perPopulation || defaultValues.perPopulation,
    chartType: chartType || defaultValues.chartType,
    countries: countries || defaultValues.countries,
    fromDate: fromDate || defaultValues.fromDate,
    toDate: toDate || defaultValues.toDate,
    scale: scale || defaultValues.scale,
  }
  return initial
};

export default getInitialChartParams;
